import React, { useState, useMemo } from 'react'
import { Segment, Message, Icon } from 'semantic-ui-react'
import request from 'services/http'
import { finalize, tap } from 'rxjs/operators'
// import { toast } from 'react-toastify'
import { useSubscription } from 'utils'
import './Combustiveis.scss'

export default function PreviaPedidos() {

    // const [previaNovos, setPreviaNovos] = useState(null)
    // const [previaCompletos, setPreviaCompletos] = useState(null)
    // const [previaProcesso, setPreviaProcesso] = useState(null)
    // const [previaErro, setPreviaErro] = useState(null)
    const [isSubmitting] = useState(false)

    const [tipoPedido] = useState({
        tipo: 2
    })

    //GET PRÉVIAS
    const submitPrevia$ = useMemo(() => request({
        url: '/validfisco/dashboard/previaPedidos',
        method: 'GET',
        params: { ...tipoPedido }
    }).pipe(
        tap(({ response }) => {
            // if(response.data.length <= 0) {
            //     toast.error('Dados não encontrados.')
            //     return
            // } else {
            //     console.log(response.data)
            // }
        }),
        finalize(() => console.log('ok'))
    ), [tipoPedido])
    useSubscription(submitPrevia$, isSubmitting)

    return (
        <div id='previa-style'>
            <div className="row mx-0">
                <div className="col px-0">

                    <Segment.Group horizontal>
                        <Segment className='styleSegmentMessage' >
                            <Message className='hoverMessage1' info icon title="Clique para ver os Pedidos">
                                <Icon name='bars' style={{ width: '40px' }} />
                                <Message.Content>
                                    <Message.Header>Novos Pedidos: <Icon loading name='spinner' /></Message.Header>
                                    <p>Cadastrados a partir de: 01/01/202</p>
                                </Message.Content>
                            </Message>
                        </Segment>
                        <Segment className='styleSegmentMessage'>
                            <Message className='hoverMessage2' positive icon title="Clique para ver os Pedidos">
                                <Icon name='check' style={{ width: '40px' }} />
                                <Message.Content>
                                    <Message.Header>Completos: <Icon loading name='spinner' /></Message.Header>
                                    <p>Cadastrados a partir de: 01/01/202</p>
                                </Message.Content>
                            </Message>
                        </Segment>
                        <Segment className='styleSegmentMessage'>
                            <Message className='hoverMessage3' warning icon title="Clique para ver os Pedidos">
                                <Icon name='exclamation' style={{ width: '40px' }} />
                                <Message.Content>
                                    <Message.Header>Em Processo: <Icon loading name='spinner' /></Message.Header>
                                    <p>Cadastrados a partir de: 01/01/202</p>
                                </Message.Content>
                            </Message>
                        </Segment>
                        <Segment className='styleSegmentMessage'>
                            <Message className='hoverMessage4' error icon title="Clique para ver os Pedidos">
                                <Icon name='cancel' style={{ width: '40px' }} />
                                <Message.Content>
                                    <Message.Header>Erro: <Icon loading name='spinner' /></Message.Header>
                                    <p>Cadastrados a partir de: 01/01/202</p>
                                </Message.Content>
                            </Message>
                        </Segment>
                    </Segment.Group>
                </div>
            </div>
        </div>
    )

}
